<template>
  <div class="calcu-wrap">
    <div class="calcu-bar">
      <van-tabs
        v-model="active"
        line-width="16"
        line-height="4"
        color="#FFC600"
        @click="tabClick"
      >
        <van-tab @click="busnessClick" name="busness">
          <template #title>
            <span class="titleFont">商业贷款</span>
          </template>
          <router-link class="link-font" to="/"></router-link>
        </van-tab>
        <van-tab @click="pubaccuClick" name="pubaccu">
          <template #title>
            <span class="titleFont">公积金贷款</span>
          </template>
          <router-link class="link-font" to="/pubaccu"></router-link>
        </van-tab>
        <van-tab @click="compositionClick" name="composition">
          <template #title>
            <span class="titleFont">组合贷款</span>
          </template>
          <router-link class="link-font" to="/composition"></router-link>
        </van-tab>
      </van-tabs>
      <!-- <span @click="busnessClick" :class="{ active: active === 'busness' }">
        <router-link class="link-font" to="/">商业贷款</router-link>
      </span>
      <span @click="pubaccuClick" :class="{ active: active === 'pubaccu' }">
        <router-link class="link-font" to="/pubaccu">公积金贷款</router-link>
      </span>
      <span
        @click="compositionClick"
        :class="{ active: active === 'composition' }"
      >
        <router-link class="link-font" to="/composition">组合贷款</router-link>
      </span> -->
    </div>
    <!-- 贷款计算器子路由 -->
    <router-view />
  </div>
</template>

<script>
import $http from "../utils/request";
import sensors from "@/utils/sensors";
import { getWebViewEnvSync } from "@/utils/sen";
export default {
  created() {
    this.active = this.$route?.name;
    // 初始化定位信息

    this.$store.commit("setLocation", {
      cityId: this.$route.query?.cityid,
      cityName: this.$route.query?.cityname,
      hideBroker: this.$route.query?.hideBroker,
    });

    // 初始化用户id
    if (this.$route.query.userid) {
      this.$store.commit("setUserId", this.$route.query.userid);
    }
    $http({
      url: `/appapi/normals/${this.$store.state.location.cityId}/v1/loancalculation2`,
      method: "get",
    }).then((res) => {
      const max_fund_loan_value = res.data.max_fund_loan_value;
      if (res.data) {
        this.$store.commit(
          "setFirstDownpaymentPercent",
          res.data.first_downpayment_percent,
        );
        this.$store.commit("setFirstMaxFundLoan", max_fund_loan_value.first);
        this.$store.commit("setSecondMaxFundLoan", max_fund_loan_value.second);
        // 存储有关利率的字典
        const com_rate = res.data.loan_price.com_loan.loan_rate;
        const com_rate_1 = res.data.loan_price.com_loan.loan_rate_1;
        const fund_rate = res.data.loan_price.fund_loan.loan_rate;
        const fund_rate_5 = res.data.loan_price.fund_loan.loan_rate_5;
        this.$store.commit("setRate", {
          com_rate,
          com_rate_1,
          fund_rate,
          fund_rate_5,
        });
        let loanTimeObj = res.data.house_price.com_loan.loan_time;
        let loanTimeList = Object.keys(loanTimeObj).map(
          (item) => loanTimeObj[item],
        );
        // 存储有关贷款年限的字典
        this.$store.commit("setLoanTime", loanTimeList);

        // 公积金贷款年限
        let fundLoanTimeObj = res.data.house_price.fund_loan.loan_time;
        let fundLoanTimeList = Object.keys(fundLoanTimeObj).map(
          (item) => fundLoanTimeObj[item],
        );
        this.$store.commit("setFundLoanTime", fundLoanTimeList);
      }
    });
    let platform =
      getWebViewEnvSync() == "IOS" || getWebViewEnvSync() == "Android"
        ? "APP"
        : getWebViewEnvSync() == "miniprogram"
          ? "小程序"
          : "WAP";
    sensors.track("BuytoolExposure", {
      source_pvar: platform,
      elementname_var: "首页",
      page_name: "房贷计算器页",
      city_pvar: this.$store.state.location.cityName,
    });
  },
  methods: {
    tabClick(value) {
      switch (value) {
        case "busness":
          this.$router.replace(
            `/?cityid=${this.$store.state.location.cityId}&cityname=${this.$store.state.location.cityName}&hideBroker=${this.$route.query?.hideBroker}`,
          );
          break;
        case "pubaccu":
          this.$router.replace(
            `/pubaccu?cityid=${this.$store.state.location.cityId}&cityname=${this.$store.state.location.cityName}&hideBroker=${this.$route.query?.hideBroker}`,
          );
          break;
        case "composition":
          this.$router.replace(
            `/composition?cityid=${this.$store.state.location.cityId}&cityname=${this.$store.state.location.cityName}&hideBroker=${this.$route.query?.hideBroker}`,
          );
          break;
      }
    },
  },
  mounted() {
    document.getElementsByTagName("body")[0].style.background = "#F4F4F4";
    window?.disableSafeArea && window?.disableSafeArea();
  },
  updated() {
    this.active = this.$route.name;
  },

  data() {
    return {
      active: "busness",
    };
  },
};
</script>

<style scoped>
.calcu-wrap {
  background-color: #f8f8f8;
  width: 750px;
}
.calcu-bar {
  height: 112px;
  background-color: #fff;
}
.calcu-bar /deep/ .van-tab {
  margin-top: 6px;
  line-height: 34px;
}
.calcu-bar /deep/ .van-tab--active .titleFont {
  font-weight: 500;
  font-size: 34px;
  color: #222222;
  line-height: 34px;
}
.titleFont {
  font-weight: 400;
  font-size: 34px;
  color: #222222;
  line-height: 34px;
}
</style>
